/* ════════════════════════════════════════════════════════════════════
   sk-collection.js — standard collection page interactivity.
   Ported from the claude.ai/design "Collection Template" prototype; the
   demo's fake bag is replaced with the real Shopify AJAX cart
   (/cart/add.js + /cart.js) and the site-wide cart drawer (sk-cart:refresh).

   All products are server-rendered by Liquid (real data, SEO-indexable);
   this script only shows/hides/reorders cards already on the page — every
   filter, sort and price change is instant with zero network requests.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var root = document.querySelector("[data-skc]");
  if (!root) return;

  var grid     = root.querySelector("[data-skc-grid]");
  if (!grid) return;
  var cards    = Array.prototype.slice.call(grid.querySelectorAll(".skc-card"));
  var pageSize = parseInt(root.getAttribute("data-skc-page-size"), 10) || 12;

  /* toolbar / bar live in a sibling section — query document-wide */
  var bar        = document.querySelector("[data-skc-bar]");
  var sortSel    = document.querySelector("[data-skc-sort]");
  var countEl    = document.querySelector("[data-skc-count]");
  var countLabel = document.querySelector("[data-skc-count-label]");
  var activeRow  = document.querySelector("[data-skc-active]");
  var fCountEl   = document.querySelector("[data-skc-fcount]");
  var empty      = root.querySelector("[data-skc-empty]");
  var emptyClear = root.querySelector("[data-skc-empty-clear]");
  var loadMore   = root.querySelector("[data-skc-loadmore]");
  var loadCount  = loadMore ? loadMore.querySelector(".n") : null;

  /* sheet (mobile) */
  var filterBtn = document.querySelector("[data-skc-filter-open]");
  var veil      = root.querySelector("[data-skc-veil]");
  var sheet     = root.querySelector("[data-skc-sheet]");
  var sheetClose= root.querySelector("[data-skc-sheet-close]");
  var sheetClear= root.querySelector("[data-skc-sheet-clear]");
  var sheetApply= root.querySelector("[data-skc-sheet-apply]");

  /* ── filter state ─────────────────────────────────────── */
  var state = {
    types: {}, tags: {}, inStock: false,
    priceBucket: null, sort: (sortSel && sortSel.value) || "featured"
  };
  var visibleLimit = pageSize;

  function cardTypes(c) { return (c.getAttribute("data-type") || "").split(/\s+/).filter(Boolean); }
  function cardTags(c)  { return (c.getAttribute("data-tags") || "").split(/\s+/).filter(Boolean); }
  function cardPrice(c) { return parseFloat(c.getAttribute("data-price")) || 0; }
  function cardAvail(c) { return c.getAttribute("data-stock") !== "out"; }

  function anyTrue(obj) { for (var k in obj) { if (obj[k]) return true; } return false; }

  /* ── price buckets (preset chips) ─────────────────────── */
  var priceChips = Array.prototype.slice.call(root.querySelectorAll("[data-skc-price]"));
  function bucketRange(val) {
    var a = (val || "").split("-");
    return { min: parseFloat(a[0]) || 0, max: (a[1] === "" || a[1] == null) ? Infinity : parseFloat(a[1]) };
  }
  function priceInBucket(p, val) { var r = bucketRange(val); return p >= r.min && p < r.max; }
  function priceLabel(val) {
    var c = priceChips.filter(function (x) { return x.getAttribute("data-skc-price") === val; })[0];
    return c ? c.textContent.trim() : val;
  }
  priceChips.forEach(function (chip) {
    chip.addEventListener("click", function () {
      var v = chip.getAttribute("data-skc-price");
      state.priceBucket = (state.priceBucket === v) ? null : v; /* single-select toggle */
      syncControls(); apply();
    });
  });
  /* hide buckets that match zero products (computed once from all cards) */
  (function hideEmptyBuckets() {
    var seen = {};
    priceChips.forEach(function (chip) {
      var v = chip.getAttribute("data-skc-price");
      if (seen[v] == null) seen[v] = cards.filter(function (c) { return priceInBucket(cardPrice(c), v); }).length;
      if (seen[v] === 0) chip.hidden = true;
    });
  })();

  /* ── type checkboxes ──────────────────────────────────── */
  var typeBoxes = Array.prototype.slice.call(root.querySelectorAll("[data-skc-type]"));
  typeBoxes.forEach(function (box) {
    box.addEventListener("change", function () {
      state.types[box.getAttribute("data-skc-type")] = box.checked;
      syncControls(); apply();
    });
  });

  /* ── in-stock ─────────────────────────────────────────── */
  var stockBoxes = Array.prototype.slice.call(root.querySelectorAll("[data-skc-instock]"));
  stockBoxes.forEach(function (box) {
    box.addEventListener("change", function () { state.inStock = box.checked; syncControls(); apply(); });
  });

  /* ── tag chips ────────────────────────────────────────── */
  var tagChips = Array.prototype.slice.call(root.querySelectorAll("[data-skc-tag]"));
  tagChips.forEach(function (chip) {
    chip.addEventListener("click", function () {
      var t = chip.getAttribute("data-skc-tag");
      state.tags[t] = !state.tags[t];
      syncControls(); apply();
    });
  });

  /* reflect state back into every (sidebar + sheet) control copy */
  function syncControls() {
    typeBoxes.forEach(function (b) { b.checked = !!state.types[b.getAttribute("data-skc-type")]; });
    stockBoxes.forEach(function (b) { b.checked = state.inStock; });
    tagChips.forEach(function (c) {
      var on = !!state.tags[c.getAttribute("data-skc-tag")];
      c.classList.toggle("on", on);
      c.setAttribute("aria-pressed", on ? "true" : "false");
    });
    priceChips.forEach(function (c) {
      var on = state.priceBucket === c.getAttribute("data-skc-price");
      c.classList.toggle("on", on);
      c.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  /* ── sort ─────────────────────────────────────────────── */
  function sortCards(arr) {
    var s = state.sort;
    var copy = arr.slice();
    copy.sort(function (a, b) {
      if (s === "price-asc")  return cardPrice(a) - cardPrice(b);
      if (s === "price-desc") return cardPrice(b) - cardPrice(a);
      if (s === "newest")     return (+b.getAttribute("data-date")||0) - (+a.getAttribute("data-date")||0);
      if (s === "rated")      return (parseFloat(b.getAttribute("data-rating"))||0) - (parseFloat(a.getAttribute("data-rating"))||0);
      /* featured = original order */
      return (+a.getAttribute("data-order")||0) - (+b.getAttribute("data-order")||0);
    });
    return copy;
  }
  if (sortSel) {
    sortSel.addEventListener("change", function () { state.sort = sortSel.value; visibleLimit = pageSize; apply(); });
  }

  /* ── apply filters + sort + paging ────────────────────── */
  function matches(c) {
    var ct = cardTags(c);
    /* Product type group — OR within the group (tag-based) */
    if (anyTrue(state.types)) {
      var typeOk = false;
      for (var ty in state.types) { if (state.types[ty] && ct.indexOf(ty) !== -1) { typeOk = true; break; } }
      if (!typeOk) return false;
    }
    /* Dietary group — OR within the group */
    if (anyTrue(state.tags)) {
      var dietOk = false;
      for (var t in state.tags) { if (state.tags[t] && ct.indexOf(t) !== -1) { dietOk = true; break; } }
      if (!dietOk) return false;
    }
    if (state.inStock && !cardAvail(c)) return false;
    if (state.priceBucket && !priceInBucket(cardPrice(c), state.priceBucket)) return false;
    return true;
  }

  function apply() {
    var matched = sortCards(cards.filter(matches));

    /* reorder DOM: matched (sorted) first, then the rest */
    var matchedSet = matched;
    matchedSet.forEach(function (c) { grid.appendChild(c); });
    cards.forEach(function (c) { if (matched.indexOf(c) === -1) grid.appendChild(c); });

    /* show up to the visible limit, hide the rest */
    var shown = 0;
    cards.forEach(function (c) { c.classList.add("hide"); });
    matched.forEach(function (c) {
      if (shown < visibleLimit) { c.classList.remove("hide"); shown++; }
    });

    /* count + label */
    if (countEl) countEl.textContent = matched.length;
    if (countLabel) countLabel.textContent = matched.length === 1 ? "product" : "products";

    /* empty state */
    if (empty) empty.classList.toggle("show", matched.length === 0);
    grid.style.display = matched.length === 0 ? "none" : "";

    /* load more */
    if (loadMore) {
      var remaining = matched.length - shown;
      loadMore.hidden = remaining <= 0;
      if (loadCount) loadCount.textContent = Math.min(remaining, pageSize);
    }

    /* active filter row + filter-count badge */
    renderActive();
    var fc = activeCount();
    if (fCountEl) { fCountEl.textContent = fc; fCountEl.hidden = fc === 0; }
    if (sheetApply) sheetApply.textContent = "Show " + matched.length + (matched.length === 1 ? " product" : " products");
  }

  function activeCount() {
    var n = 0;
    for (var k in state.types) if (state.types[k]) n++;
    for (var t in state.tags) if (state.tags[t]) n++;
    if (state.inStock) n++;
    if (state.priceBucket) n++;
    return n;
  }

  function labelFor(val) {
    return val.replace(/-/g, " ").replace(/\b\w/g, function (m) { return m.toUpperCase(); });
  }

  function renderActive() {
    if (!activeRow) return;
    activeRow.innerHTML = "";
    var chips = [];
    for (var ty in state.types) if (state.types[ty]) chips.push({ kind: "type", key: ty, label: typeLabel(ty) });
    for (var tg in state.tags)  if (state.tags[tg])  chips.push({ kind: "tag",  key: tg, label: tagLabel(tg) });
    if (state.inStock) chips.push({ kind: "stock", key: "stock", label: "In stock" });
    if (state.priceBucket) chips.push({ kind: "price", key: "price", label: priceLabel(state.priceBucket) });
    if (chips.length === 0) { activeRow.hidden = true; return; }
    activeRow.hidden = false;

    var lbl = document.createElement("span");
    lbl.className = "skc-active__label"; lbl.textContent = "Filtering:";
    activeRow.appendChild(lbl);

    chips.forEach(function (c) {
      var b = document.createElement("button");
      b.type = "button"; b.className = "skc-active__chip";
      b.innerHTML = c.label + ' <span class="x" aria-hidden="true">×</span>';
      b.setAttribute("aria-label", "Remove filter " + c.label);
      b.addEventListener("click", function () { removeChip(c); });
      activeRow.appendChild(b);
    });

    var clr = document.createElement("button");
    clr.type = "button"; clr.className = "skc-active__clear"; clr.textContent = "Clear all";
    clr.addEventListener("click", clearAll);
    activeRow.appendChild(clr);
  }

  function typeLabel(key) {
    var box = typeBoxes.filter(function (b) { return b.getAttribute("data-skc-type") === key; })[0];
    if (box) { var s = box.closest(".skc-opt"); if (s) return s.getAttribute("data-label") || labelFor(key); }
    return labelFor(key);
  }
  function tagLabel(key) {
    var chip = tagChips.filter(function (c) { return c.getAttribute("data-skc-tag") === key; })[0];
    return chip ? chip.textContent.trim() : labelFor(key);
  }

  function removeChip(c) {
    if (c.kind === "type")  state.types[c.key] = false;
    if (c.kind === "tag")   state.tags[c.key] = false;
    if (c.kind === "stock") state.inStock = false;
    if (c.kind === "price") state.priceBucket = null;
    syncControls(); apply();
  }

  function clearAll() {
    state.types = {}; state.tags = {}; state.inStock = false;
    state.priceBucket = null;
    syncControls(); visibleLimit = pageSize; apply();
  }
  if (emptyClear) emptyClear.addEventListener("click", clearAll);

  /* ── load more ────────────────────────────────────────── */
  if (loadMore) {
    loadMore.addEventListener("click", function () { visibleLimit += pageSize; apply(); });
  }

  /* ── sticky toolbar shadow ────────────────────────────── */
  if (bar && "IntersectionObserver" in window) {
    var sentinel = document.createElement("div");
    sentinel.style.cssText = "width:100%;height:1px;pointer-events:none;";
    bar.parentNode.insertBefore(sentinel, bar);
    new IntersectionObserver(function (entries) {
      bar.classList.toggle("stuck", !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(sentinel);
  }

  /* ── mobile filter sheet ──────────────────────────────── */
  function openSheet() { if (veil) veil.classList.add("open"); if (sheet) { sheet.classList.add("open"); sheet.setAttribute("aria-hidden", "false"); } }
  function closeSheet() { if (veil) veil.classList.remove("open"); if (sheet) { sheet.classList.remove("open"); sheet.setAttribute("aria-hidden", "true"); } }
  if (filterBtn) filterBtn.addEventListener("click", openSheet);
  if (sheetClose) sheetClose.addEventListener("click", closeSheet);
  if (veil) veil.addEventListener("click", closeSheet);
  if (sheetApply) sheetApply.addEventListener("click", closeSheet);
  if (sheetClear) sheetClear.addEventListener("click", function () { clearAll(); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeSheet(); });

  /* ── fade-in ──────────────────────────────────────────── */
  if ("IntersectionObserver" in window) {
    var fxObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("vis"); fxObs.unobserve(e.target); } });
    }, { threshold: 0.06 });
    document.querySelectorAll(".skc-fx").forEach(function (el) { fxObs.observe(el); });
  }

  /* ── bag pill → real Shopify cart ─────────────────────── */
  var bag      = root.querySelector("[data-skc-bag]");
  var bagCount = bag ? bag.querySelector("[data-skc-bag-count]") : null;
  var bagTotal = bag ? bag.querySelector("[data-skc-bag-total]") : null;

  function money(cents) {
    var n = cents / 100;
    return "$" + (Number.isInteger(n) ? n : n.toFixed(2));
  }
  function renderBag(cart, bump) {
    if (!bag) return;
    var items = cart ? cart.item_count : 0;
    if (bagCount) {
      bagCount.textContent = items;
      if (bump) { bagCount.classList.add("bump"); setTimeout(function () { bagCount.classList.remove("bump"); }, 250); }
    }
    if (bagTotal) bagTotal.textContent = items > 0 ? "· " + money(cart.total_price) : "";
  }
  function refreshBag(showBar, bump) {
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderBag(cart, bump); if (showBar && cart.item_count > 0 && bag) bag.classList.add("show"); })
      .catch(function () {});
  }

  cards.forEach(function (card) {
    var btn = card.querySelector("[data-skc-add]");
    if (!btn) return;
    var variantId = btn.getAttribute("data-variant-id");
    var label = btn.textContent;
    if (!variantId) return; /* multi-variant or sold-out: button is a link / disabled, leave it */

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      btn.setAttribute("disabled", "disabled");
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
        .then(function () {
          btn.classList.add("added"); btn.textContent = "Added ✓";
          if (bag) bag.classList.add("show");
          refreshBag(true, true);
          document.dispatchEvent(new CustomEvent("sk-cart:refresh"));
          setTimeout(function () {
            btn.classList.remove("added"); btn.textContent = label; btn.removeAttribute("disabled");
          }, 1600);
        })
        .catch(function (err) {
          btn.removeAttribute("disabled");
          /* eslint-disable-next-line no-console */
          console.error("Collection add-to-cart failed:", err);
        });
    });
  });

  if (bag && "IntersectionObserver" in window) {
    var bagObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { refreshBag(true, false); bagObs.disconnect(); } });
    }, { threshold: 0.05 });
    bagObs.observe(grid);
  }

  /* ── init ─────────────────────────────────────────────── */
  apply();
  refreshBag(false, false);
})();
